import React from 'react';
import { usePortal } from '../contexts/PortalContext';
import type { ClientRoute } from '../contexts/PortalContext';
import { brand } from '../data/projects';
import { ContactPortal } from './ContactPortal';
const NAV: {
  label: string;
  route: ClientRoute;
}[] = [{
  label: 'Project',
  route: 'project'
}, {
  label: 'Deliverables',
  route: 'episodes'
}, {
  label: 'Files',
  route: 'files'
}, {
  label: 'Schedule',
  route: 'schedule'
}];
export function ClientShell({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    clientRoute,
    goClient,
    activeProject,
    changeClientName
  } = usePortal();
  const [contactOpen, setContactOpen] = React.useState(false);
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-32" data-mp="2a8xbc397vcmm">
      <header className="border-b border-rule" data-id="element-33" data-mp="2f8jokcp1osvf">
        <div className="mx-auto flex max-w-portal flex-col gap-5 px-6 py-6 sm:px-10 md:flex-row md:items-center md:justify-between" data-id="element-34" data-mp="32zff76hrli13">
          <button type="button" onClick={() => goClient('home')} className="flex items-center gap-3.5 self-start text-left transition-opacity duration-150 ease-out hover:opacity-60" data-id="element-35" data-mp="37r765i4u1prr">
            <img src={brand.mark} alt="" className="h-7 w-7" data-id="element-36" data-mp="dfhoeawbvgob" />
            <span className="label tracking-label text-ink" data-id="element-37" data-mp="r5bhj5ev8n3u">
              Portal Productions
              <span className="label-sm mt-2 block text-mute" data-id="element-38" data-mp="me331uyoibjt">Client Portal</span>
            </span>
          </button>

          <div className="flex items-center justify-between gap-8 md:justify-end" data-id="element-39" data-mp="111xwjdkigjxy">
            <nav aria-label="Client sections" data-id="element-40" data-mp="w4xuddqs81c4">
              <ul className="m-0 flex list-none gap-6 p-0 sm:gap-8" data-id="element-41" data-mp="w68y5dk89938">
                {NAV.map(item => {
                const active = clientRoute === item.route || item.route === 'episodes' && clientRoute === 'episode';
                return <li key={item.route} data-id="element-42" data-mp="3bxd99h6gzt2q">
                      <button type="button" onClick={() => goClient(item.route)} aria-current={active ? 'page' : undefined} className={['label whitespace-nowrap pb-1 transition-colors duration-150 ease-out', active ? 'border-b border-ink text-ink' : 'border-b border-transparent text-mute hover:text-ink'].join(' ')} data-id="element-43" data-mp="37ugvc3rvkl54">
                        {item.label}
                      </button>
                    </li>;
              })}
              </ul>
            </nav>
            <button type="button" onClick={() => setContactOpen(true)} className="label whitespace-nowrap text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-44" data-mp="23i8ibt6h4hkh">
              Contact Portal
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-portal px-6 pb-32 pt-14 sm:px-10 sm:pt-20" data-id="element-45" data-mp="2hfev974inm1s">{children}</main>

      <footer className="border-t border-rule" data-id="element-46" data-mp="5s1rom5v9ab5">
        <div className="mx-auto flex max-w-portal flex-wrap items-center justify-between gap-4 px-6 py-8 sm:px-10" data-id="element-47" data-mp="1sazqf4lso51">
          <p className="label m-0 text-mute" data-id="element-48" data-mp="3szn9wa72k1bg">
            {activeProject.client} · {activeProject.name}
          </p>
          <div className="flex flex-wrap items-center gap-8" data-id="element-49" data-mp="3o1lovjq31rxc">
            {/* Kept quietly here so somebody else on this computer can take over. */}
            <button type="button" onClick={changeClientName} className="label m-0 text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-50" data-mp="kiir5zyxxq5e">
              Change Name
            </button>
            <button type="button" onClick={() => setContactOpen(true)} className="label m-0 text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-51" data-mp="asz8aub89waj">
              Portal Productions · Dubai
            </button>
          </div>
        </div>
      </footer>

      <ContactPortal open={contactOpen} onClose={() => setContactOpen(false)} data-id="element-52" data-mp="o29drjzcpnin" />
    </div>;
}